import React, { useState, useEffect } from 'react';
import {loadModules, setDefaultOptions} from 'esri-loader'
import ArcGIS from 'terraformer-arcgis-parser'
import Terraformer from 'terraformer'
import WKT from 'terraformer-wkt-parser'
import {Feature, Geometry, Properties, featureCollection, bbox, bboxPolygon, buffer, 
  point as turfPoint, lineString as turfLineString, polygon as turfPolygon } from '@turf/turf';

const MapEditEnterprise = (props: any) => {

  const [map, setMap] = useState(0);

  setDefaultOptions({css: true})
  const styles = {
    container: {
      height: '70vh',
    },
    mapDiv: {
      height: '69vh',
      border: '3px solid #ccc',
      background: '#ccc',
      borderRadius: '10px',
    },
  }

  // const handleGeomAdded = (map: any) => {
  //   // let inputValue = ''
  //   // inputValue = event.value
  //   // setEntrepreneurs(event)
  //   // formik.setFieldValue('entrepreneur_id', inputValue)
  //   // return {inputValue}
  //   console.log('entrou handle');
  // }
  // const [geom_point, geom_line, geom_polygon, type_geometry] = useState(0)
  // useEffect(handleGeomAdded, [name])

  useEffect(() => {

    loadModules([
      "esri/widgets/Sketch",
      "esri/Map",
      "esri/layers/GraphicsLayer",
      "esri/views/MapView",
      "esri/geometry/Extent",
      "esri/geometry/SpatialReference",
      "esri/Graphic",
      "esri/geometry/Point",
      "esri/geometry/Polyline",
      "esri/geometry/Polygon",
      "esri/geometry/geometryEngine"
    ])
      .then(([Sketch, Map, GraphicsLayer, MapView, Extent, SpatialReference, Graphic, Point, Polyline, Polygon, geometryEngine]) => {
        
        let layer = new GraphicsLayer({});
        
        // criação do mapa
        const map = new Map({
          basemap: 'hybrid',
          layers: [layer],
        })

        // criação da view
        const view = new MapView({
          container: 'viewDiv',
          map: map,
          zoom: 4,
          center: [0, 0],
          // spatialReference: new SpatialReference({ wkid:4326 })
        })

        let startExtent = new Extent({
            xmin: -73.9872354804,
            ymin: -33.7683777809,
            xmax: -34.7299934555,
            ymax: 5.24448639569,
            spatialReference: new SpatialReference({ wkid:4326 })
        });

        view.extent = startExtent;


        const sketch = new Sketch({
            layer: layer,
            view: view,
            creationMode: "update",
            availableCreateTools: ["point", "polyline", "polygon"],
            defaultUpdateOptions: {
                enableRotation: false,
                enableScaling: false,
                multipleSelectionEnabled: false,
                toggleToolOnClick: false,
                tool: "reshape"
            },
        });

        sketch.on("create", function(event: { state: string }) {
          if (event.state === "complete") {
              sketch.availableCreateTools = [];
              
              let geomOject = layer.graphics.items[0];
              let geomtype = geomOject.geometry.type;

              let geojson = ArcGIS.parse(geomOject.geometry);
              Terraformer.Tools.toGeographic(geojson);
              let geomWKT = WKT.convert(geojson);

              if(geomtype == "polyline")
                geomtype = "line";

              props.setTypeGeometry(geomtype);
              props.setGeomPoint(null);
              props.setGeomLine(null);
              props.setGeomPolygon(null);

              switch(geomtype){
                case "point":
                    props.setGeomPoint(geomWKT);
                    break;
                case "line":
                    props.setGeomLine(geomWKT);
                    break;
                case "polygon":
                    props.setGeomPolygon(geomWKT);
                    break;
              }
            }
        });

        sketch.on("update", function(event: { toolEventInfo: { type: string | string[] }; graphics: { geometry: { type: string } }[] }) {
            if (event.toolEventInfo && event.toolEventInfo.type.includes("move") && event.graphics[0].geometry.type != "point"){
                sketch.cancel();
            }
        });

        view.ui.add(sketch, "top-right");

        sketch.on("delete", function(event: any) {
          sketch.availableCreateTools = ["point", "polyline", "polygon"];
          props.setTypeGeometry(null);
          props.setGeomPoint(null);
          props.setGeomLine(null);
          props.setGeomPolygon(null);
        });

        // var turf_features = [];

        var type_geometry = props.type_geometry;
        if(type_geometry){

            if(type_geometry == "point"){
                var geomPointWKT =  props.geom_point;
                var geojson = WKT.parse(geomPointWKT);
                Terraformer.Tools.toMercator(geojson);
                var arcgisPoint: any = ArcGIS.convert(geojson);
                console.log('point', arcgisPoint);
                arcgisPoint.type = "point";
                arcgisPoint.spatialReference = { wkid: 3857 };

                var graphic = new Graphic({
                    geometry: arcgisPoint,
                    symbol: {
                      type: "simple-marker",
                      path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
                      color: "#187bcd",
                      size: 24,
                    }
                });
                layer.graphics.add(graphic);
                var buffer = geometryEngine.geodesicBuffer(arcgisPoint, 0.1, "miles");
                view.goTo(buffer.extent);
            }
            else if(type_geometry == "line"){
                var geomLineWKT = props.geom_line;
                var geojson = WKT.parse(geomLineWKT);
                Terraformer.Tools.toMercator(geojson);
                var arcgisLine: any = ArcGIS.convert(geojson);
                arcgisLine.type = "polyline";
                arcgisLine.spatialReference = { wkid: 3857 };

                var polylineGraphic = new Graphic({
                    geometry: arcgisLine,
                    symbol: {
                        type: "simple-line",
                        color: [ 0, 0, 248, 1 ],
                        width: "2px",
                    }
                });

                layer.graphics.add(polylineGraphic);
                view.goTo(Polyline.fromJSON(arcgisLine).extent);
            }
            else if(type_geometry == "polygon"){
                var geomPolygonWKT = props.geom_polygon;
                var geojson = WKT.parse(geomPolygonWKT);
                Terraformer.Tools.toMercator(geojson);
                var arcgisPolygon: any = ArcGIS.convert(geojson);
                arcgisPolygon.type = "polygon";
                arcgisPolygon.spatialReference = { wkid: 3857 };

                var polygonGraphic = new Graphic({
                    geometry: arcgisPolygon,
                    symbol: {
                        type: "simple-fill",  // autocasts as new SimpleFillSymbol()
                        color: [ 0, 0, 248, 0.1 ],
                        style: "solid",
                        outline: {  // autocasts as new SimpleLineSymbol()
                            color: [ 0, 0, 248, 1 ],
                            width: 1
                        }
                    }
                });

                layer.graphics.add(polygonGraphic);
                view.goTo(Polygon.fromJSON(arcgisPolygon).extent);
            }

            // if(turf_features.length > 0){
            //   let turf_features_collection = featureCollection(turf_features);
            //   let collectionTurfBBox = bbox(turf_features_collection);
            //   let turf_polygon = bboxPolygon(collectionTurfBBox);
            //   let turf_expanded_polygon = buffer(turf_polygon, 1000, {units: 'meters'});
            //   let expdandedTurBBox = bbox(turf_expanded_polygon);
  
            //   let newExtent = new Extent({
            //       xmin: expdandedTurBBox[0],
            //       ymin: expdandedTurBBox[1],
            //       xmax: expdandedTurBBox[2],
            //       ymax: expdandedTurBBox[3],
            //       spatialReference: new SpatialReference({ wkid:4326 })
            //   });
            //   view.extent = newExtent;
          // }

            sketch.availableCreateTools = [];
        }

      })

      .catch((err) => console.error(err))
    //eslint-disable-next-line
  }, [props.longitude, props.latitude, props.name, props.description, props.zoom, props.duration, props.setGeomPoint, props.setGeomLine, props.setGeomPolygon, props.setTypeGeometry, props.geom_point, props.geom_line, props.geom_polgyon, props.type_geometry])

  return (
    <div style={styles.container}>
      <div id='viewDiv' style={styles.mapDiv}></div>{' '}
    </div>
  )
}

export {MapEditEnterprise}